import React, { useState, useRef } from "react";
import "./SidebarAdminBusinessSelection.scoped.scss";
import * as Utils from "core/common/utils";
import useStore from "core/custom-hooks/useStore";
import { useFormik } from "formik";
import * as Validations from "core/common/validations";
import * as Yup from "yup";
import { setCurrentBusiness } from "core/store/actionCreators";
import { SUBBUSINESS_ID_LOCAL_STORAGE_KEY } from "core/common/constants/localstorage";
import clsx from "clsx";
import * as TagManager from "core/common/seo/tagManager";

const SidebarAdminBusinessSelection = () => {
    const { dispatch, businessRepository, state } = useStore();
    const { isAdmin, business } = state;
    const { business_id: currentBusinessId } = business || {};
    const [errorMsg, setErrorMsg] = useState("");
    const formRef = useRef();
    const inputRef = useRef();
    const susbmitRef = useRef();

    const isTestMode = false;
    const handleSubmit = async ({ businessNumber }) => {
        try {
            Utils.loadingWrapper(dispatch, async () => {

                const { data: responseData } = await businessRepository.get(businessNumber);
                const { message, data } = responseData || {};

                if (!Utils.isSuccessfulRequest(dispatch, responseData)) {
                    setErrorMsg(message);
                    return setTimeout(() => { setErrorMsg(""); }, 5000);
                }

                TagManager.sendBusinessId(businessNumber);
                localStorage.setItem(SUBBUSINESS_ID_LOCAL_STORAGE_KEY, businessNumber);
                localStorage.removeItem("link-ofir")
                dispatch(setCurrentBusiness(data));
                formik.resetForm();
                formRef.current.blur();

            });
        } finally { }
    }

    const formik = useFormik({
        initialValues: {
            businessNumber: ""
        },
        validationSchema: Yup.object({
            businessNumber: Validations.businessNumber
        }),
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: handleSubmit,
    });

    if (!isAdmin) return null;

    const clientSideError = Utils.getFormikError("businessNumber", formik);
    const error = clientSideError || errorMsg;
    if (clientSideError) {
        setTimeout(() => {
            delete formik.errors.businessNumber;
        }, 1000);
    }

    const renderTestButton = (businessId, name) => {
        if (currentBusinessId !== businessId && isTestMode) {
            return (
                <button onClick={() => {
                    formik.setValues({ businessNumber: businessId });
                    susbmitRef.current.click();
                }}>
                    {name}
                </button>
            );
        }
    };

    return (
        <div className="side_bar_search">
            <form className="no-arrows" onSubmit={formik.handleSubmit} ref={el => { formRef.current = el; }}>
                <input
                    ref={el => { inputRef.current = el; }}
                    tabIndex="1"
                    pattern="[0-9]*"
                    type="number"
                    placeholder="הזן מספר עסק"
                    onKeyUp={(e) => e.key === 13 && susbmitRef.current.click()}
                    {...formik.getFieldProps("businessNumber")} />
                <i className={clsx("fa", `fa-${(formik.values.businessNumber !== "" ? "long-arrow-left" : "search")}`)} onClick={() => susbmitRef.current.click()}></i>
                {renderTestButton(80282477, "פרגו")}
                {renderTestButton(26150520, "דקל")}
                <input type="submit" style={{ display: "none" }} ref={el => { susbmitRef.current = el; }} />
                {error && <span className="error_msg">{error}</span>}
            </form>
        </div>
    );
}

export default SidebarAdminBusinessSelection;